module.exports = __webpack_public_path__ + "static/media/art51.6aa151e6.jpg";